import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Quote from "@/pages/Quote";
import About from "@/pages/About";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import MockupGallery from "@/pages/MockupGallery";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop brand={null} />} />
            <Route path="/shop/dtf" element={<Shop brand="dtf" />} />
            <Route path="/shop/tsc" element={<Shop brand="tsc" />} />
            <Route path="/shop/:productId" element={<ProductDetail />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/about" element={<About />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/admin/mockups" element={<MockupGallery />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
